import { render, staticRenderFns } from "./OrganizationStatisticsCards.vue?vue&type=template&id=a62d49f4"
import script from "./OrganizationStatisticsCards.vue?vue&type=script&lang=js"
export * from "./OrganizationStatisticsCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports